import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-content-background",
  "use": "icon-content-background-usage",
  "viewBox": "0 0 1276 854",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1276 854\" id=\"icon-content-background\">\r\n<defs>\r\n<linearGradient id=\"icon-content-background_PSgrad_0\" x1=\"0%\" x2=\"100%\" y1=\"0%\" y2=\"0%\">\r\n  <stop offset=\"0%\" stop-color=\"rgb(16,37,47)\" stop-opacity=\"0.72157\" />\r\n  <stop offset=\"100%\" stop-color=\"rgb(14,32,41)\" stop-opacity=\"1\" />\r\n</linearGradient>\r\n\r\n</defs>\r\n<path fill-rule=\"evenodd\" fill-opacity=\"0.82\" fill=\"url(#icon-content-background_PSgrad_0)\" d=\"M-0.000,-0.000 L1276.000,-0.000 L1276.000,854.000 L-0.000,854.000 L-0.000,-0.000 Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/broad/content-background.svg
// module id = hVyj
// module chunks = 24